"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = permissions;
var _types = require("../../actions/permission/types");
function permissions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === "".concat(_types.GET_VIEW_PERMISSIONS, "_SUCCESS")) {
    return action.payload;
  }
  return state;
}